import { createGraphqlApiHandler } from 'api/apollo-client'
import graphqlApi from 'api/graphql-api'
import appLoadingFeatureActions from 'feature/app-loading.actions'
import { GetPopularSpinQueryVariables } from 'graphql/generated/graphql'
import { Redux } from 'types/local'
import { createActionsSet } from 'utils/redux'

const types = {
  GET_GAMES: createActionsSet.api('games.get-games'),
}

const getGames =
  (variables: GetPopularSpinQueryVariables) => async (dispatch: Redux.Dispatch, getState: Redux.GetState) => {
    dispatch({
      type: types.GET_GAMES.REQUEST,
    })
    dispatch(appLoadingFeatureActions.start())
    try {
      const handleApi = createGraphqlApiHandler(dispatch, getState)
      const response = await handleApi(graphqlApi.getPopularSpin(variables))
      dispatch({
        type: types.GET_GAMES.SUCCESS,
        payload: response,
      })
    } catch (e) {
      dispatch(appLoadingFeatureActions.finish())
      dispatch({ type: types.GET_GAMES.FAILED, payload: e })
    } finally {
      dispatch(appLoadingFeatureActions.finish())
    }
  }

export const gamesActions = {
  types,
  getGames,
}
